import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store'
import { abilitiesPlugin } from '@casl/vue';
import ability from './resources/ability';
import i18n from './i18n'
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import PrimeVue from 'primevue/config';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Row from 'primevue/row';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
//import Spinner from 'primevue/spinner';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import { apolloProvider } from '@/plugins/apollo'
import BadgeDirective from 'primevue/badgedirective';
import keycloakPlugin from '@/plugins/keycloak';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import './assets/layout/layout.scss';

loadConfig();

function loadConfig() {
  Vue.config.productionTip = false;
  Vue.use(ToastService);
  Vue.use(abilitiesPlugin, ability);
  Vue.directive('tooltip', Tooltip);
  Vue.directive('badge', BadgeDirective)
  Vue.use(PrimeVue);

  Vue.component('Accordion', Accordion);
  Vue.component('AccordionTab', AccordionTab);
  Vue.component('AutoComplete', AutoComplete);
  Vue.component('Breadcrumb', Breadcrumb);
  Vue.component('Button', Button);
  Vue.component('Calendar', Calendar);
  Vue.component('Card', Card);
  Vue.component('Carousel', Carousel);
  Vue.component('Chart', Chart);
  Vue.component('Checkbox', Checkbox);
  Vue.component('Chips', Chips);
  Vue.component('Column', Column);
  Vue.component('ColumnGroup', ColumnGroup);
  Vue.component('ContextMenu', ContextMenu);
  Vue.component('DataTable', DataTable);
  Vue.component('DataView', DataView);
  Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
  Vue.component('Dialog', Dialog);
  Vue.component('Dropdown', Dropdown);
  Vue.component('Editor', Editor);
  Vue.component('Fieldset', Fieldset);
  Vue.component('FileUpload', FileUpload);
  Vue.component('FullCalendar', FullCalendar);
  Vue.component('Inplace', Inplace);
  Vue.component('InputSwitch', InputSwitch);
  Vue.component('InputText', InputText);
  Vue.component('InputNumber', InputNumber);
  Vue.component('InputMask', InputMask);
  Vue.component('Listbox', Listbox);
  Vue.component('MegaMenu', MegaMenu);
  Vue.component('Menu', Menu);
  Vue.component('Menubar', Menubar);
  Vue.component('Message', Message);
  Vue.component('MultiSelect', MultiSelect);
  Vue.component('OrderList', OrderList);
  Vue.component('OrganizationChart', OrganizationChart);
  Vue.component('OverlayPanel', OverlayPanel);
  Vue.component('Paginator', Paginator);
  Vue.component('Panel', Panel);
  Vue.component('PanelMenu', PanelMenu);
  Vue.component('Password', Password);
  Vue.component('PickList', PickList);
  Vue.component('ProgressBar', ProgressBar);
  Vue.component('RadioButton', RadioButton);
  Vue.component('Row', Row);
  Vue.component('Rating', Rating);
  Vue.component('SelectButton', SelectButton);
  Vue.component('Slider', Slider);
  Vue.component('Sidebar', Sidebar);
  //Vue.component('Spinner', Spinner);
  Vue.component('SplitButton', SplitButton);
  Vue.component('Steps', Steps);
  Vue.component('TabMenu', TabMenu);
  Vue.component('TabView', TabView);
  Vue.component('TabPanel', TabPanel);
  Vue.component('Textarea', Textarea);
  Vue.component('TieredMenu', TieredMenu);
  Vue.component('Toast', Toast);
  Vue.component('Toolbar', Toolbar);
  Vue.component('ToggleButton', ToggleButton);
  Vue.component('Tree', Tree);
  Vue.component('TreeTable', TreeTable);
  Vue.component('TriStateCheckbox', TriStateCheckbox);
  //Vue.component('ValidationMessage', ValidationMessage);

  loadKeycloak();
}

async function loadKeycloak() {

  return new Promise(resolve => {
    Vue.use(keycloakPlugin, {
      init: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        // Keycloak 24 dejo de incluir el nonce en el access token y en el
        // refresh token; solo va en el id token. keycloak-js 21 lo compara en
        // los tres, no cuadra, y el login entra en bucle de recarga.
        //
        // La 24 del adaptador lo arregla, pero usa ?. y ?? y esta cadena de
        // build (node 12, vue-cli 3, webpack 4) no sabe interpretarlos. Ver
        // el README del pipeline.
        //
        // Se desactiva la comprobacion y se activa PKCE S256 en su lugar, que
        // ata el codigo de autorizacion a esta instancia del cliente. Para un
        // flujo de codigo es una proteccion mas fuerte que el nonce, asi que
        // el conjunto queda mejor que antes, no peor. El parametro state se
        // sigue comprobando igual.
        useNonce: false,
        pkceMethod: 'S256'
      },
      config: {
        url: process.env.VUE_APP_KEYCLOAK_URL, 
        realm: process.env.VUE_APP_KEYCLOAK_REALM, 
        clientId: process.env.VUE_APP_KEYCLOACK_CLIENT
      },
      onReady: () => {
        storeProfile();
        initializeApp();
        resolve();
      },
      onInitError: error => {
        console.error('Keycloak failed to initialize');
        console.error(error);
      }
    });
  });
}

function storeProfile() {
  store.commit('setProfile', Vue.prototype.$keycloak);
}

function initializeApp() {
  new Vue({
    router,
    apolloProvider,
    render: h => h(App),
    store,
    i18n
  }).$mount('#app');
}